/* The modal dialog should open on page load */
$("li.survey-answer, li.survey-answer-2, li.survey-answer-3").mouseenter(function(){

  $(this)
  .addClass('hover')
  .find('.survey-icon')
  .addClass('hovered');

}).mouseleave(function(){

  $(this)
  .removeClass('hover')
  .find('.survey-icon')
  .removeClass('hovered');
  
});

$('#survey-2').hide();
$('#survey-3').hide();
$('#survey-details').hide();
$('#survey-completed').hide();

$("li.survey-answer").on("click", function(){
  var answer_1 = $(this).find('a').attr('data-answer');
  $("#answer_1").val(answer_1);
  $("li.survey-answer").removeClass('active');
 $(this).addClass('active');
 $('#survey').hide();
 $('#survey-2').show();
});

$("#back-1").on("click", function(){
 $('#survey-2').hide();
 $('#survey').show();
});

$("li.survey-answer-2").on("click", function(){
  var answer_2 = $(this).find('a').attr('data-answer');
  $("#answer_2").val(answer_2);
  $("li.survey-answer-2").removeClass('active');
 $(this).addClass('active');
 $('#survey').hide();
 $('#survey-2').hide();
 $('#survey-3').show();
});

$("#back-2").on("click", function(){
 $('#survey-3').hide();
 $('#survey-2').show();
 $('#survey').hide();
});

$("li.survey-answer-3").on("click", function(){
  var answer_3 = $(this).find('a').attr('data-answer');
 $("#answer_3").val(answer_3); 
 var d = new Date();
 $("#datetime").val(d);
 $("li.survey-answer-3").removeClass('active');
 $(this).addClass('active');
 $('#survey').hide();
 $('#survey-2').hide();
 $('#survey-3').hide();
 $('#survey-details').show();
});

$("#back-3").on("click", function(){
 $('#survey-details').hide();
 $('#survey-3').show();
 $('#survey').hide();
 $('#survey-2').hide();
});

$(document).ready(function($) {
        
	$("#survey_form").validate({
        rules: {
            username: "required",                    
            email: {
			  required: true,
			  email: true
			},
            dob: "required",
            gender: "required"
        },
        messages: {
            name: "Please enter your Name",                   
            email: "Please enter your Email Id",
            dob: "Please enter your Date of Birth",
            gender: "This field is required"
        },
        errorPlacement: function(error, element) 
        {
            if ( element.is(":radio") ) 
            {
                error.appendTo( element.parents('.form-group') );
            }
            else 
            { // This is the default behavior 
                error.insertAfter( element );
            }
        },
        submitHandler: function(form) {
            //form.submit();
			$.ajax({
				url: "https://script.google.com/macros/s/AKfycbzfDRo1impDK-GktA0_-lbplJkMOm_kFUherDaqiX6fMLrhvzp09Q6aKV9W1PisdbMO/exec",
				type: "POST",
				cache: false,
				data: $('#survey_form').serialize(),
				success: function(res) {
					console.log(res);
                    window.history.replaceState(null, null, "?thankyou");
					$('#survey').hide();
					$('#survey-2').hide();
					$('#survey-3').hide();
					$('#survey-details').hide();
					$('#survey-completed').show();
				}
			});
        }
                
    });
});